import type { ObjectsConfigInterface } from '@/map-phaser-new/interfaces/scene/objects/objectsConfigInterface'
import { interactiveObjectsConfig } from './interactiveObjects/mainConfig'
import { animatedObjectsWithPathsConfig } from './animatedObjectsWithPaths/mainConfig'

export const objectsConfig: ObjectsConfigInterface = {
  animatedObjectsWithPaths: animatedObjectsWithPathsConfig,
  interactiveObjects: interactiveObjectsConfig,
}
